import { defineComponent as _defineComponent } from 'vue'
import { AppDirection } from '@/enums/app-direction';
import { useMetaStore } from '@/helpers/composables/useStores';
import { computed, onMounted, ref } from 'vue';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'Top10TitleSwiper',
  props: {
    titleCount: null,
    showSwappers: { type: Boolean, default: true },
    showTitle: { type: Boolean, default: true },
    loop: { type: Boolean, default: true },
    showBullets: { type: Boolean, default: true }
  },
  emits: ['slideChange'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { titleCount: number, showSwappers: boolean, showTitle: boolean, loop: boolean, showBullets: boolean };

onMounted(() => setTimeout(initSwiper, 0));

let swiper: any;
const currentSlideIndex = ref(0);
const swiperContainer = ref('swiperContainer');



const { appDirection } = useMetaStore();

const items = computed(() => Array.from({ length: props.titleCount }));

const isRTL = computed(() => appDirection.value === AppDirection.RTL);

function next(allowRTL: boolean = false) {
	if (isRTL.value && !allowRTL) {
		prev(true);
		return;
	}

	if (currentSlideIndex.value === props.titleCount - 1) {
		swiper.slideTo(0);
	} else {
		swiper.slideTo(currentSlideIndex.value + 1);
	}
}

function prev(allowRTL: boolean = false) {
	if (isRTL.value && !allowRTL) {
		next(true);
		return;
	}
	if (currentSlideIndex.value === 0) {
		swiper.slideTo(props.titleCount - 1);
	} else {
		swiper.slideTo(currentSlideIndex.value - 1);
	}
}
function changeSlideIndex(index: number, nextIndex: number): void {
	currentSlideIndex.value = nextIndex;

	const position = index + 1;

	if (nextIndex !== index) {
		if (Math.abs(index - nextIndex) === props.titleCount - 1)
			// handle when swiping right from lastIndex or left from 0 index separately
			emits('slideChange', { direction: index === props.titleCount - 1 ? 'right' : 'left', position });
		else emits('slideChange', { direction: index < nextIndex ? 'right' : 'left', position });
	}
}
const initSwiper = async (initialSlideIndex: number = 0) => {
	const { default: Swiper } = await import('tiny-swiper');
	try {
		if (swiperContainer.value) {
			swiper = new Swiper(swiperContainer.value, {
				initialSlide: initialSlideIndex,
				loop: props.loop,
			});

			swiper.on('before-slide', (current: number, _: any, next: number) => changeSlideIndex(current, next));
		}
	} catch (e) {
		console.log('error', e);
	}
};

expose({
	next,
	prev,
	currentSlideIndex,
});

return { __sfc: true,swiper, currentSlideIndex, swiperContainer, emits, props, appDirection, items, isRTL, next, prev, changeSlideIndex, initSwiper, faChevronRight, faChevronLeft }
}

})